module.exports = __webpack_public_path__ + "img/img-gzt-4.6bd259ba.png";